import { useEffect, useState } from "react";
import { Users, CreditCard, FileText, IndianRupee } from "lucide-react";
import api from "@/lib/api";

const Card = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white rounded-2xl border border-brand-borderc p-5">
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-white ${color}`}><Icon className="w-5 h-5" /></div>
    <div className="mt-3 text-2xl font-bold text-brand-navy">{value}</div>
    <div className="text-sm text-brand-muted">{label}</div>
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="p-10 text-brand-muted">Loading…</div>;

  return (
    <div className="px-5 lg:px-10 py-8 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Overview</h1>
      <p className="text-sm text-brand-muted mt-1">Real-time DraftVoice AI metrics.</p>

      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card icon={Users} label="Total users" value={stats.total_users} color="bg-gradient-primary" />
        <Card icon={Users} label="Active users" value={stats.active_users} color="bg-gradient-secondary" />
        <Card icon={CreditCard} label="Paid users" value={stats.paid_users} color="bg-gradient-warm" />
        <Card icon={IndianRupee} label="Revenue (INR)" value={`₹${stats.revenue_inr.toLocaleString()}`} color="bg-brand-navy" />
      </div>

      <div className="mt-6 grid lg:grid-cols-2 gap-5">
        <div className="bg-white rounded-2xl border border-brand-borderc p-5">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold text-brand-navy">Recent signups</h2>
            <span className="text-xs text-brand-muted">{stats.total_dictations} drafts created</span>
          </div>
          <div className="mt-3 space-y-2">
            {stats.recent_signups.length === 0 ? (
              <div className="text-sm text-brand-muted">No signups yet.</div>
            ) : stats.recent_signups.map((u) => (
              <div key={u.id} className="flex items-center justify-between text-sm border-b border-brand-borderc last:border-0 py-2">
                <div>
                  <div className="font-semibold text-brand-navy">{u.name}</div>
                  <div className="text-xs text-brand-muted">{u.email}</div>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-brand-surface text-brand-navy capitalize">{u.plan}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-gradient-primary text-white rounded-2xl p-5">
          <FileText className="w-8 h-8 opacity-90" />
          <h3 className="mt-3 font-semibold text-lg">DraftVoice is live</h3>
          <p className="text-white/85 text-sm mt-1">Manage users, plans, payments, coupons, announcements and support from this panel.</p>
        </div>
      </div>
    </div>
  );
}
